import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { ReactElement, useState } from 'react';

export interface ExportProceduresModalProps {
  onClose: DialogProps['onClose'];
  onExportAll: () => void;
  onExportFiltered: () => void;
}

const ExportProceduresModal = ({
  onExportAll,
  onExportFiltered,
  onClose,
}: ExportProceduresModalProps): ReactElement => {
  const [isLoading, setIsLoading] = useState(false);

  const handleExportAll = () => {
    setIsLoading(true);
    onExportAll();
    onClose(undefined, undefined);
  };

  const handleExportFiltered = () => {
    setIsLoading(true);
    onExportFiltered();
    onClose(undefined, undefined);
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
      aria-labelledby="export-procedures-dialog-title"
      data-testid="export-procedures-modal"
      data-cy="export-procedures-modal"
    >
      <DialogTitle
        id="export-procedures-dialog-title"
        sx={{
          paddingInline: 3,
        }}
      >
        Export Dataset Metadata
      </DialogTitle>
      <DialogContent
        sx={{
          paddingInline: 3,
        }}
      >
        <DialogContentText>
          Filters are currently applied to slides or cases. Export the current filtered dataset metadata, or export the
          whole dataset metadata instead.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          data-testid="export-all-button"
          data-cy="export-all-button"
          disableElevation
          onClick={handleExportAll}
          variant="contained"
          disabled={isLoading}
        >
          Whole Dataset Metadata
        </Button>
        <Button
          data-testid="export-filtered-button"
          data-cy="export-filtered-button"
          disableElevation
          onClick={handleExportFiltered}
          variant="contained"
          disabled={isLoading}
        >
          Filtered Dataset Metadata
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportProceduresModal;
